import { Routes, Route, Navigate } from 'react-router-dom';
// import EmployerDashboard from '../../module/employer/pages/EmployerDashboard';
// import PostJob from '../../module/employer/pages/PostJob';
import PrivateRoute from './privateRoute';
import UserResolver from '../reolvers/userResolver';

const EmployerRoutes = () => {
    return (
        <UserResolver>
            <Routes>
                {/* <Route path="/employer/dashboard" element={<PrivateRoute><EmployerDashboard /></PrivateRoute>} />
                <Route path="/employer/post-job" element={<PrivateRoute><PostJob /></PrivateRoute>} /> */}
                <Route path="*" element={<Navigate to="/employer/dashboard" replace />} />
            </Routes>
        </UserResolver>
    );
};

export default EmployerRoutes;